import React, { useEffect, useRef } from "react";
import { CloseOutlined } from "@ant-design/icons";
import { createPortal } from "react-dom";
import styles from "./MobileModal.module.css";

export interface MobileModalProps {
  visible: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  footerText?: string;
  className?: string;
}

export const MobileModal: React.FC<MobileModalProps> = ({
  visible,
  onClose,
  title,
  children,
  footerText,
  className,
}) => {
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (visible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [visible]);

  if (!visible) return null;

  const handleOverlayClick = (e: React.MouseEvent) => {
    // 防止點擊 Ant Design 的彈出層（如下拉菜單）時關閉模態框
    // 這些彈出層通過 Portal 渲染在 body 中，但在 React 事件樹中會冒泡到這裡
    const target = e.target as HTMLElement;
    if (
      target.closest(".ant-select-dropdown") ||
      target.closest(".ant-picker-dropdown") ||
      target.closest(".ant-dropdown")
    ) {
      return;
    }

    if (modalRef.current && !modalRef.current.contains(e.target as Node)) {
      onClose();
    }
  };

  return createPortal(
    <div className={styles.overlay} onClick={handleOverlayClick}>
      <div className={`${styles.modal} ${className || ""}`} ref={modalRef}>
        <div className={styles.header}>
          <div className={styles.title}>{title}</div>
          <div className={styles.closeBtn} onClick={onClose}>
            <CloseOutlined />
          </div>
        </div>
        <div className={styles.body}>{children}</div>
        {footerText && <div className={styles.footer}>{footerText}</div>}
      </div>
    </div>,
    document.body
  );
};
